// 处理表格合并单元格
export default {
  data() {
    return {
      pos: 0,
      rowAndColumn: [],
    }
  },
  methods: {
    createTableWithSpan(tableData, colname) {
      this.rowAndColumn = [];
      tableData.forEach((i, index) => {
        if (index == 0) {
          this.rowAndColumn.push(1);
          this.pos = 0
        } else {
          if (tableData[index][colname] == tableData[index -1][colname]) {
            this.rowAndColumn[this.pos] += 1;
            this.rowAndColumn.push(0)
          } else {
            this.rowAndColumn.push(1);
            this.pos = index
          }
        }
      })
    },
    /**
     * 合并单元格
     * @param {*} vm 表格实例
     * @param {*} colname 判断条件 列值相同的合并
     * @param {*} mergeColumnArr 需要合并的单元格
     */
    mergeCells(vm, colname, mergeColumnArr, elKey) {
      let self = this
      if (!(vm && vm.data)) return
      this.createTableWithSpan(vm.data, colname)
      this.$nextTick(() => {
        const handler = function(i){
          const rowspan = self.rowAndColumn[i]
          if (rowspan == 1) {
            $(this).attr('colspan', 1).attr('rowspan', 1)
          } else if (rowspan == 0) {
            this.remove()
          } else {
            $(this).attr('colspan', 1).attr('rowspan', rowspan)
          }
        }
        mergeColumnArr.forEach(column => {
          $(`.table-${vm.elKey || elKey} [data-column="${column}"]`).each(handler)
        })
      })
    },
  }
}